import * as React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  FormControl,
  Button,
  Stack,
  Checkbox,
  InputAdornment,
  OutlinedInput,
  Box,
  Avatar,
  ListItemAvatar,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import InfiniteScroll from "react-infinite-scroll-component";

export const StampCardCustomersDialog = (props) => {
  const {
    state,
    handleSelect,
    isSelectedUser,
    handleChange,
    disabled,
    loadNextPage,
    hasMorePages,
    HandleFilter,
  } = props;

  const stringAvatar = (name, id) => {
    const isSelected = isSelectedUser(id);
    const nameSplit = (name || "").split(" ").filter(Boolean);
    const first = nameSplit[0]?.[0] || "";
    const second = nameSplit.length > 1 ? nameSplit[1][0] : "";
    const initials = `${first}${second}`;

    return {
      sx: {
        fontSize: "16px",
        background: isSelected ? "#1560D4" : "#edf3fc",
        color: isSelected ? "#fff" : "#000",
      },
      children: isSelected ? <DoneIcon /> : initials,
    };
  };

  return (
    <>
      <Stack
        justifyContent="space-between"
        height="100%"
        gap="8px"
        maxHeight={"calc(100% - 24px)"}
      >
        <Stack pt="24px" gap="8px">
          <FormControl size="small" fullWidth={true}>
            <OutlinedInput
              placeholder="Search"
              sx={{
                height: "48px",
                ".MuiOutlinedInput-input": {
                  pl: "0px !important",
                },
              }}
              size="small"
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon size="large" />
                </InputAdornment>
              }
              value={state?.searchText}
              endAdornment={
                state?.searchText && (
                  <InputAdornment
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      HandleFilter("search", "");
                    }}
                    position="end"
                  >
                    <CloseIcon size="large" />
                  </InputAdornment>
                )
              }
              fullWidth
              onChange={(e) => {
                HandleFilter("search", e.target.value);
              }}
            />
          </FormControl>
        </Stack>

        <Box
          id="stampCardCustomersScroll"
          sx={{ height: "100%", overflow: "auto" }}
          fullWidth
        >
          <InfiniteScroll
            scrollableTarget="stampCardCustomersScroll"
            dataLength={state?.customers?.length || 0}
            next={loadNextPage}
            hasMore={hasMorePages}
            loader={
              hasMorePages ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  Loading...
                </Box>
              ) : null
            }
          >
            {state?.customers?.length > 0 ? (
              <List sx={{ width: "100%", bgcolor: "background.paper" }}>
                {state.customers.map((data, index) => (
                  <ListItem
                    alignItems="flex-start"
                    key={index}
                    sx={{
                      height: "68px",
                      padding: " 0px 12px 12px 0px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleSelect(data.id)}
                  >
                    <ListItemAvatar>
                      <Avatar
                        alt={data.name}
                        {...stringAvatar(data.name, data.id)}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <>
                          <Typography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="subtitle2"
                            color="text.primary"
                          >
                            {data?.name}
                          </Typography>
                        </>
                      }
                      secondary={
                        <>
                          <Typography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="caption"
                            color="text.secondary"
                            fontWeight={400}
                          >
                            {data.email}
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : !hasMorePages ? (
              <Stack
                justifyContent="center"
                alignItems="center"
                height="100%"
                mt="40px"
              >
                <Typography
                  component="span"
                  variant="caption"
                  color="text.secondary"
                  fontWeight={400}
                >
                  No customers found
                </Typography>
              </Stack>
            ) : null}
          </InfiniteScroll>
        </Box>

        <Button
          sx={{ height: "48px" }}
          variant="contained"
          fullWidth
          onClick={handleChange}
          disabled={disabled}
        >
          Save
        </Button>
      </Stack>
    </>
  );
};
